import React, { useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import SearchMealsQuery from './SearchMealsQuery';
import {
  CookbookMealSearchEdge,
  MealsSearchCriteriaInputType,
  SearchMealsQueryResult,
  SearchVariables,
} from '../types';

interface ICookbookSearchConnectorApollo {
  children: ({
    searchCookbookMeals,
    loading,
    meals,
    called,
  }: {
    searchCookbookMeals: (searchCriteria?: MealsSearchCriteriaInputType) => Promise<any>;
    loading: boolean;
    meals: CookbookMealSearchEdge[];
    called: boolean;
  }) => React.ReactElement;
}

const CookbookSearchConnectorApollo: React.FC<ICookbookSearchConnectorApollo> = ({ children }) => {
  const [searchMeals, { loading: apolloLoading, called }] = useLazyQuery<
    SearchMealsQueryResult,
    SearchVariables
  >(SearchMealsQuery);

  const [isSearching, setIsSearching] = useState(false);
  const [searchResults, setSearchResults] = useState<CookbookMealSearchEdge[]>([]);

  const createSearchMeals = async (searchCriteria?: MealsSearchCriteriaInputType) => {
    setIsSearching(true);

    try {
      const result = await searchMeals({ variables: { searchCriteria } });

      if (result.data?.cookbook.meals.edges) {
        setSearchResults(result.data.cookbook.meals.edges);
      }

      return result;
    } finally {
      setIsSearching(false);
    }
  };

  return children({
    searchCookbookMeals: createSearchMeals,
    loading: apolloLoading || isSearching,
    meals: searchResults,
    called: called || searchResults.length > 0,
  });
};

export default CookbookSearchConnectorApollo;
